import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
// Vendor Components
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
// Custom Components
import { TextFieldAdapter } from '../Form/TextFieldAdapter';
import { FormIcon } from '../Form/FormIcon';
import AuthStepper from '../Stepper/AuthStepper';
import Snackbar from 'material-ui/Snackbar';

// Steps
import LoginStep from '../Form/Steps/LoginStep';
// import SignUpStep from '../Form/Steps/SignUpStep';
// import PaymentStep from '../Form/Steps/PaymentStep';
// import VerificationStep from '../Form/Steps/VerificationStep';
// import ConfirmStep from '../Form/Steps/ConfirmStep';
// import PasswordResetStep from '../Form/Steps/PasswordResetStep';

// Utilities
import { required, isEmail, composeValidators, isNum, passwordMustMatch } from '../Form/validation';

let _submitting;
let _pristine;

class LoginStartConsult extends Component {
    
    state = {
        errors: {
            code: 'NO ERRORS',
            message: 'No errors'
        },
        showSignUp: false,
        snackAutoHideDuration: 4000,
        snackMessage: '',
        snackOpen: false,
        stepToShow: 0
    };

    componentDidMount() {
        if (this.props.userId) {
            this.props.getClientData(this.props.userId);
        }
        if (!this.props.userId) {
            this.props.initAuthFlowRequiredStatus();
        }
    }

    advanceStepper = () => {
        // console.log('Prev Step:', this.state.stepToShow);
        const currentStep = this.state.stepToShow;
        // If this is the final step then close otherwise advance.
        if (this.state.stepToShow !== this.state.finalStep){
            // console.log('not finished yet, advancing...');
            this.setState({
                stepToShow: currentStep + 1
            }, ()=>{
                // console.log('New Step:', this.state.stepToShow);
            })
        } else {
            // console.log('Youre at the last step cant advance closing instead');
            this.handleCloseDialog();
        }
    }
    
    reverseStepper = () => {
        const currentStep = this.state.stepToShow;
        if (currentStep > 0) {
            this.setState({
                stepToShow: currentStep - 1
            });
        }
    }
    
    handleCloseDialog = () => {
        // console.log('%cCLOSING DIALOG...','color: gold');
        this.props.handleClose();
        this.resetBookingDialog();
        this.determineAuthFlowRequirement();
    }

    determineAuthFlowRequirement = () => {
        if (this.props.userId) {
            this.props.endAuthFlowRequiredStatus();
        } else {
            this.props.initAuthFlowRequiredStatus();
        }
    }

    resetBookingDialog = () => {
        // console.log('Running all dialog resets (Stepper, Choice, Values).');
        this.resetStepper();
        this.resetCurrentDialog();
        this.resetFormValues();
    }

    resetStepper = () => {
        this.setState({
            stepToShow: 0
        })
    }

    resetCurrentDialog = () => {
        // console.log('Resetting dialog to login');
        this.props.setCurrentDialog('login');
    }
    
    resetFormValues = () => {
        this.setState({
            formValues: null
        });
        this.props.resetBookingData();
    }

    resetErrors = (reset)=> {
        reset();
        this.setState({
            errors: null
        });
    }
    
    stepperControls = {
        advanceStepper: this.advanceStepper,
        reverseStepper: this.reverseStepper,
        setFinalStep: this.setFinalStep,
    }

    setFinalStep = (finalStep) => {
        this.setState({
            finalStep: finalStep
        });
    }

    setFormStates = (submitting, pristine) => {
        _submitting = submitting;
        _pristine = pristine;
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.errorData !== nextProps.errorData){
            // console.log('changing error state from', this.state.errors);
            this.setState({
                errors: nextProps.errorData
            }, ()=>{
                // console.log('%cNEW ERROR STATE IS:','color: greenyellow');
                // console.log(this.state.errors);
            })
        }

        if ((nextProps.userId !== this.props.userId && !!nextProps.userId && nextProps.emailVerified) || (nextProps.emailVerified && this.props.emailVerified !== nextProps.emailVerified)) {
            this.props.notifyUser({
                message: 'Welcome, you are now logged in.',
                textColor: 'white'
            })    
            .then((res) => {
                this.props.handleClose();
                this.startConsult();
            })
            .catch(console.log);
        }
    }
    
    getLoginStep = () => (
        <LoginStep 
            label="Login" 
            handleClose={this.handleCloseDialog} 
            errors={this.props.errorData} 
            stepperControls={this.stepperControls} 
            resetErrors={this.resetErrors} 
            resetBookingDialog={this.resetBookingDialog}
            handleChooseAuthDialog={this.handleChooseAuthDialog} 
            hideSignUp
        />
    )

    getPasswordResetStep = () => (
        <div style={{ marginTop: -10, marginBottom: 10 }}>
            <PasswordResetStep 
                handleClose={this.handleCloseDialog} 
                errors={this.props.errorData} 
                resetErrors={this.resetErrors} 
                stepperControls={this.stepperControls} 
                handleChooseAuthDialog={this.handleChooseAuthDialog}
                resetBookingDialog={this.resetBookingDialog}
            />
        </div>
    )

    startConsult = () => {
        if(this.props.startConsult) {
            this.props.startConsult();
        }
    }

    render() {
        const { title, handleClose, open, user } = this.props;
        
        const { currentDialog } = this.state;
        
          return (
            <div>
                {this.props.currentDialog === 'login' && this.props.authFlowRequired &&
                    <Dialog
                        title={title}
                        modal={true}
                        open={open}
                        autoScrollBodyContent={true}
                    >
                        <div style={{ marginTop: 0, marginBottom: 10 }}>
                            { this.getLoginStep() }
                        </div>
                       
                    </Dialog>
                }
                { this.props.currentDialog === 'reset' && this.props.authFlowRequired &&
                    <Dialog
                        title={title}
                        modal={true}
                        open={open}
                        autoScrollBodyContent={true}
                    >
                        <div style={{ marginTop: -10, marginBottom: 10 }}>
                                { this.getPasswordResetStep(handleClose, this.props.errorData) }
                        </div>
                    </Dialog>
                }
                { !this.props.authFlowRequired &&
                    <div>
                        {this.startConsult()}
                    </div>
                }
            </div>
          );
    }
  }

  const mapStateToProps = ({auth, client, dialog}) => {
    if (auth.serverError) {
        // console.log('%cSERVER ERROR @ MSTP','color: greenyellow');
        // console.log(auth.serverError);
    }
    return {
        authFlowRequired: auth.isAuthFlow,
        clientData: client.clientData,
        currentDialog: dialog.current,
        emailVerified: auth.authData.emailVerified,
        errorData: auth.serverError,
        passwordData: auth.passwordData,
        user: auth.authData,
        userEmail: (auth.authData) ? auth.authData.email : null,
        userId: (auth.authData) ? auth.authData.id : null,
    };
  }

  export default connect(mapStateToProps, actions)(LoginStartConsult);

  /*
  
  title
  altActionText
  mainActionText
  open 
  handleClose
  
  */


// WEBPACK FOOTER //
// ./src/js/components/Dialog/LoginStartConsult.jsx